var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsNumber, IsOptional } from 'class-validator';
import { TrainingReminderTime } from '../enums/training-reminder-time.enum.js';
export class UpdateUserSettingsDto {
    systemNotificationRegistrationEnabled;
    systemNotificationShopEnabled;
    systemNotificationPatientHandOverEnabled;
    systemNotificationAppointmentEnabled;
    systemNotificationExerciseProgramEnabled;
    systemNotificationTrainingReminderEnabled;
    systemNotificationProgramStatsEnabled;
    systemNotificationInvoicesEnabled;
    emailNotificationRegistrationEnabled;
    emailNotificationShopEnabled;
    emailNotificationPatientHandOverEnabled;
    emailNotificationAppointmentEnabled;
    emailNotificationExerciseProgramEnabled;
    emailNotificationTrainingReminderEnabled;
    emailNotificationProgramStatsEnabled;
    emailNotificationInvoicesEnabled;
    pushNotificationRegistrationEnabled;
    pushNotificationShopEnabled;
    pushNotificationPatientHandOverEnabled;
    pushNotificationAppointmentEnabled;
    pushNotificationExerciseProgramEnabled;
    pushNotificationTrainingReminderEnabled;
    pushNotificationProgramStatsEnabled;
    pushNotificationInvoicesEnabled;
    trainingReminderTime;
    defaultVideoCallDuration;
}
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "systemNotificationRegistrationEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "systemNotificationShopEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "systemNotificationPatientHandOverEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "systemNotificationAppointmentEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "systemNotificationExerciseProgramEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "systemNotificationTrainingReminderEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "systemNotificationProgramStatsEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "systemNotificationInvoicesEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "emailNotificationRegistrationEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "emailNotificationShopEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "emailNotificationPatientHandOverEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "emailNotificationAppointmentEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "emailNotificationExerciseProgramEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "emailNotificationTrainingReminderEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "emailNotificationProgramStatsEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "emailNotificationInvoicesEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "pushNotificationRegistrationEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "pushNotificationShopEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "pushNotificationPatientHandOverEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "pushNotificationAppointmentEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "pushNotificationExerciseProgramEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "pushNotificationTrainingReminderEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "pushNotificationProgramStatsEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateUserSettingsDto.prototype, "pushNotificationInvoicesEnabled", void 0);
__decorate([
    Expose(),
    IsEnum(TrainingReminderTime),
    IsOptional(),
    __metadata("design:type", String)
], UpdateUserSettingsDto.prototype, "trainingReminderTime", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateUserSettingsDto.prototype, "defaultVideoCallDuration", void 0);
//# sourceMappingURL=update-user-settings.dto.js.map